import styled from 'styled-components';

import { fromLarge } from 'styleUtils/mediaQueries';
import { paddingY, paddingX, extraPaddingX } from './variables';
import { purple, red, white } from 'styles/colors';

interface WrapperProps {
    isPurple: boolean;
    extraPaddingRight: boolean;
    extraPaddingLeft: boolean;
}
export const Wrapper = styled.div<WrapperProps>`
    padding: 1.5rem;
    ${fromLarge`
        padding: ${paddingY} ${paddingX};
        ${({ extraPaddingRight }): string => extraPaddingRight && `padding-right: ${extraPaddingX};`}
        ${({ extraPaddingLeft }): string => extraPaddingLeft && `padding-left: ${extraPaddingX};`}
    `};
    background-color: ${({ isPurple }): string => {
        return isPurple ? purple : red;
    }};
    display: flex;
    justify-content: center;
    flex-direction: column;

    color: ${white};
    p {
        color: ${white};
    }
    height: fill-available;
`;
